import PropTypes from 'prop-types'
import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import AdAgeLogo from '../assets/img/png/AdAge_logo.png'
import AdWeekLogo from '../assets/img/png/AdWeek_logo.png'
import DeadlineLogo from '../assets/img/png/Deadline_logo.png'
import JewishInsiderLogo from '../assets/img/png/Jewish_Insider_logo.png'
import MuseByClioLogo from '../assets/img/png/Muse_by_Clio_logo.png'
import PeopleLogo from '../assets/img/png/People_logo.png'
import SemaforLogo from '../assets/img/png/semafor-logo.png'
import SportsmastersLogo from '../assets/img/png/Sportsmasters_logo.png'
import TheHollywoodReporterLogo from '../assets/img/png/The_Hollywood_Reporter_logo.png'
import TheLosAngelesTimesLogo from '../assets/img/png/The_Los_Angeles_Times_logo.png'
import VarietyLogo from '../assets/img/png/Variety_logo.png'

const PressItem = ({ press }) => {
  const sourceName = press.source.toLowerCase()
  let source

  switch (sourceName) {
    case 'ad age':
      source = <img src={AdAgeLogo} className='w-20' alt='Ad Age' />
      break
    case 'adweek':
      source = <img src={AdWeekLogo} className='w-15' alt='AdWeek' />
      break
    case 'deadline':
      source = <img src={DeadlineLogo} className='w-25' alt='Deadline' />
      break
    case 'jewish insider':
      source = <img src={JewishInsiderLogo} className='w-40' alt='Jewish Insider' />
      break
    case 'muse by clio':
      source = <img src={MuseByClioLogo} className='w-12' alt='Muse by Clio' />
      break
    case 'people':
      source = <img src={PeopleLogo} className='w-15' alt='People' />
      break
    case 'semafor':
      source = <img src={SemaforLogo} className='w-25' alt='Semafor' />
      break
    case 'sportsmasters':
      source = <img src={SportsmastersLogo} className='w-40' alt='Sportsmasters' />
      break
    case 'the hollywood reporter':
      source = <img src={TheHollywoodReporterLogo} className='w-25' alt='The Hollywood Reporter' />
      break
    case 'the los angeles times':
      source = <img src={TheLosAngelesTimesLogo} className='w-50' alt='The Los Angeles Times' />
      break
    case 'variety':
      source = <img src={VarietyLogo} className='w-20' alt='Variety' />
      break
    default:
      source = press.source
      break
  }

  return (
    <div className='press__item' key={press.id}>
      <OutboundLink
        href={press.cta.url.path}
        target='_blank'
        rel='noreferrer noopener'
      >
        <img
          className='press__image'
          src={press.image.url}
          alt={press.headline}
        />
      </OutboundLink>
      <span className='press__source'>{source}</span>
      <OutboundLink
        className='press__headline'
        href={press.cta.url.path}
        target='_blank'
        rel='noreferrer noopener'
      >
        <span>{press.headline}</span>
      </OutboundLink>
    </div>
  )
}

PressItem.propTypes = {
  press: PropTypes.object
}

export default PressItem



// WEBPACK FOOTER //
// ./src/components/press-item.js